var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneAction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 96,
    viewBox: "0 0 72 96",
    fill: "#233E62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 55.752V74c0 2.21-1.79 4-4 4H12c-2.21 0-4-1.79-4-4V30c0-2.21 1.79-4 4-4h13.6c.302.005.589-.129.78-.363.19-.234.262-.543.196-.837-.56-2.517-.695-5.11-.4-7.672.039-.288-.05-.579-.245-.796-.193-.217-.472-.338-.763-.332H10C4.477 16 0 20.477 0 26v60c0 2.652 1.054 5.196 2.929 7.071C4.804 94.946 7.348 96 10 96h32c2.652 0 5.196-1.054 7.071-2.929C50.946 91.196 52 88.652 52 86V58.856c-.015-.48-.372-.88-.848-.948-2.029-.504-3.906-1.491-5.472-2.876-.289-.273-.711-.348-1.076-.191-.365.156-.602.514-.604.911z",
    transform: "translate(-742 -465) translate(237 179) translate(505 286)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52 0C40.96.013 32.013 8.96 32 20c0 12.684 17.828 30.656 18.584 31.416.375.376.885.588 1.416.588.531 0 1.04-.212 1.416-.588C54.172 50.656 72 32.684 72 20 71.987 8.96 63.04.013 52 0zm-7 20c0-3.866 3.134-7 7-7s7 3.134 7 7-3.134 7-7 7c-3.864-.004-6.996-3.136-7-7z",
    transform: "translate(-742 -465) translate(237 179) translate(505 286)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAction);
export default __webpack_public_path__ + "static/media/phone-action.53eb11ef.svg";
export { ForwardRef as ReactComponent };